let $items;

function cacheDOM() {
  $items = document.querySelectorAll('.js-animate-in');
}

function setupAnimations() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('js-animate-in--is-active');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.05, // 5% of the target element needs to be in the viewport
    rootMargin: '0% 0% -5% 0%', // Target must be past 5% of bottom of viewport
  });
  $items.forEach(($item) => {
    observer.observe($item);
  });
}

export default function init() {
  cacheDOM();
  if ($items && $items.length) setupAnimations();
}
